import { type IconType } from 'react-icons';
import { SiFigma, SiReact, SiAntdesign, SiTypescript, SiNextdotjs } from 'react-icons/si';
import { LuShieldCheck } from 'react-icons/lu';

type StackBadge = {
  label: string;
  icon: IconType;
};

const STACK_BADGE_REGISTRY: Record<string, StackBadge> = {
  figma: { label: 'Figma', icon: SiFigma },
  react: { label: 'React', icon: SiReact },
  'react.js': { label: 'React', icon: SiReact },
  'ant design': { label: 'Ant Design', icon: SiAntdesign },
  antd: { label: 'Ant Design', icon: SiAntdesign },
  typescript: { label: 'TypeScript', icon: SiTypescript },
  'type script': { label: 'TypeScript', icon: SiTypescript },
  'next.js': { label: 'Next.js', icon: SiNextdotjs },
  nextjs: { label: 'Next.js', icon: SiNextdotjs },
  'oauth 2.0': { label: 'OAuth 2.0', icon: LuShieldCheck },
  oauth2: { label: 'OAuth 2.0', icon: LuShieldCheck },
};

export const getStackBadge = (value: string) => {
  const key = value.trim().toLowerCase();
  return STACK_BADGE_REGISTRY[key];
};
